import bountyActionTypes from './bounties.types';

export const fetchBountiesStart = (token) => ({
    type: bountyActionTypes.FETCH_BOUNTIES_START,
    payload: token
});

export const fetchBountiesSuccess = (bounties) => ({
    type: bountyActionTypes.FETCH_BOUNTIES_SUCCESS,
    payload: bounties
});

export const fetchBountiesFailure = (error) => ({
    type: bountyActionTypes.FETCH_BOUNTIES_FAILURE,
    payload: error
});

export const claimBountyStart = ({ token, bountyId, evidence }) => ({
    type: bountyActionTypes.CLAIM_BOUNTY_START,
    payload: { token, bountyId, evidence }
});

export const claimBountySuccess = (claim) => ({
    type: bountyActionTypes.CLAIM_BOUNTY_SUCCESS,
    payload: claim
});

export const claimBountyFailure = (error) => ({
    type: bountyActionTypes.CLAIM_BOUNTY_FAILURE,
    payload: error
});
